var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95224 4.00014C5.95194 4.65159 5.55672 5.23781 4.95293 5.48238C4.34913 5.72696 3.65735 5.58104 3.20377 5.11344C2.7502 4.64583 2.62541 3.94992 2.88825 3.35385C3.1511 2.75779 3.74909 2.38059 4.40024 2.40014C5.26509 2.4261 5.95263 3.13489 5.95224 4.00014ZM6.00024 6.78414H2.80024V16.8001H6.00024V6.78414ZM11.0563 6.78414H7.87224V16.8001H11.0243V11.5441C11.0243 8.61612 14.8403 8.34412 14.8403 11.5441V16.8001H18.0003V10.4561C18.0003 5.52014 12.3523 5.70414 11.0243 8.12812L11.0563 6.78414Z",
    fill: "#010103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.ceccd5966a56fe8e0f871ed27960d7e1.svg";
export { ForwardRef as ReactComponent };